import { AppShell } from "@/components/AppShell";

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg font-serif text-[#D4AF37] mb-2">{title}</h2>
    <div className="text-sm text-[#C8C8C8] leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <AppShell>
      <div className="max-w-2xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-serif text-white mb-2">Privacy Policy</h1>
        <p className="text-xs text-[#5a5a66] mb-8">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="What we collect">
          <p>
            Name, email, profile photo, age, gender, neighborhood, bio, and WhatsApp
            number — provided by you when completing your profile. We also receive your
            name, email, and photo from Google when you sign in.
          </p>
        </Section>

        <Section title="Why we collect it">
          <p>
            To run the core service: matching you with dinners, letting planners choose
            among applicants, and letting confirmed participants coordinate over
            WhatsApp. Payment details are handled directly by Razorpay — we never see or
            store your card, UPI, or bank details.
          </p>
        </Section>

        <Section title="Who can see your information">
          <p>
            Your name, photo, age, gender, neighborhood, and bio are visible to planners
            reviewing join requests. Your WhatsApp number is shared only with the other
            confirmed participant(s) of a dinner you're matched to — never before a
            match is confirmed.
          </p>
        </Section>

        <Section title="How long we keep it">
          <p>We retain your data as long as your account is active. You may request deletion at any time by contacting us.</p>
        </Section>

        <Section title="Your rights">
          <p>
            Under the Digital Personal Data Protection Act, 2023, you have the right to
            access, correct, or request deletion of your personal data. Contact us using
            the details on our Terms of Service page.
          </p>
        </Section>

        <Section title="Third parties">
          <p>
            We use Razorpay for payments and Google for sign-in. Each has its own
            privacy policy governing the data they process on our behalf.
          </p>
        </Section>

        <p className="text-xs text-[#5a5a66] mt-10 border-t border-white/10 pt-4">
          This is a general template and has not been reviewed by a lawyer. Consult a
          qualified lawyer before relying on it for a live, real-money platform.
        </p>
      </div>
    </AppShell>
  );
}
